import axiosPrivateClient from "@/api/base/private/axiosPrivateClient";
import type { RelayIceServer } from "./types";

type RelayServerApiEntity = {
  urls?: string | string[] | null;
  server?: string | null;
  username?: string | null;
  credential?: string | null;
};

export async function fetchRelayIceServers(): Promise<RelayIceServer[]> {
  const response = await axiosPrivateClient.get<unknown>("/relay-servers");
  const body = response.data as {
    data?: RelayServerApiEntity[];
    entities?: { data?: RelayServerApiEntity[] } | RelayServerApiEntity[];
  } | RelayServerApiEntity[];

  const rawEntities = Array.isArray(body)
    ? body
    : Array.isArray(body?.data)
      ? body.data
      : Array.isArray(body?.entities)
        ? body.entities
        : Array.isArray(body?.entities?.data)
          ? body.entities.data
          : [];

  return rawEntities
    .map((server: RelayServerApiEntity): RelayIceServer => ({
      urls: server.urls ?? server.server ?? "",
      username: server.username ?? undefined,
      credential: server.credential ?? undefined,
    }))
    .filter((server): server is RelayIceServer => {
      if (Array.isArray(server.urls)) return server.urls.length > 0;
      return typeof server.urls === "string" && server.urls.trim().length > 0;
    });
}
